export function isFlattenedTreeItem(item) {
  return item.parentId !== undefined;
}
//# sourceMappingURL=types.js.map